@for (group of model.groups; track trackGroup($index, group)) {
    <ms-event-group
        [group]="group"
        [grouping]="model.grouping"
        [sportId]="model.sport.id"
        [hideFavourites]="hideFavourites"
        (toggle)="groupToggled($event)">
        @for (event of group.events; track trackEvent(index, event); let index = $index) {
            <ms-compact-event
                [event]="event"
                [isOutrightMarket]="isOutrightMarket"
                [tracking]="trackingGameDetails('NonGridable', index)"
                [media]="model.media"
                [state]="model.collapsed.events[event.id]"
                [showAllBetsButton]="showAllBetsButton"
                [hideOptionPanelHeaderForPriceBoost]="hideOptionPanelHeaderForPriceBoost"
                [betDetails]="betDetails"
                [showParticipantImage]="showParticipantImage"
                [displayCompactScoreboardEvent]="displayCompactScoreboardEvent"
                (eventClick)="eventClicked(event)"
                (collapse)="eventCollapsed(event.id, $event)" />
        }
    </ms-event-group>
}
